import { createElement } from 'react';
import type React from 'react';

import { AcceptAllRemainingButton } from '@atlassian/ai-mate-jira-admin-agent/AcceptAllRemainingButton';
import { RovodalCanvasKeys } from '@atlassian/rovodal-context/canvas-keys';

// Context handed to action renderers so a consumer can wrap the Rovodal's
// close/back behaviour however it likes.
export type RovodalActionsContext = {
	close: () => void;
};

// Top/canvas/bottom bar actions for a given canvas key. All are render functions so
// the consumer owns what the buttons do (including wrapping close/back).
export type RovodalActions = {
	topBarActions?: (ctx: RovodalActionsContext) => React.ReactNode;
	bottomBarActions?: (ctx: RovodalActionsContext) => React.ReactNode;
	canvasBarActions?: (ctx: RovodalActionsContext) => React.ReactNode;
};

// Maps a canvas key to its top/bottom bar actions. A missing entry means no
// actions, mirroring the canvas registry's default-to-nothing behaviour.
export type RovodalActionsRegistry = Partial<Record<RovodalCanvasKeys, RovodalActions>>;

export const rovodalActionsRegistry: RovodalActionsRegistry = {
	[RovodalCanvasKeys.jiraAdminAgentBlastRadiusCanvas]: {
		// Primary canvas-bar action mirroring the chat card's "Accept plan": applies
		// every plan step still pending. The button reads the open canvas from the
		// rovodal store, so it needs nothing from the actions context.
		canvasBarActions: () => createElement(AcceptAllRemainingButton),
	},
};
